import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';
import Schedule from './Schedule';
import { fetchClientsIfNeeded } from '../../clients/actions';
import { fetchLocationsIfNeeded } from '../../locations/actions';
import clients from '../../clients';
import locations from '../../locations';
import misc from '../../misc';

const ScheduleToJS = misc.lib.toJS(Schedule);

export class ScheduleContainer extends Component {
  componentDidMount() {
    this.props.fetchClientsIfNeeded();
    this.props.fetchSessionsIfNeeded();
    this.props.fetchLocationsIfNeeded();
  }

  render() {
    return (
      <ScheduleToJS
        sessions={this.props.sessions}
        allClients={this.props.allClients}
        allLocations={this.props.allLocations}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  sessions: selectors.getAllUpcoming,
  allClients: clients.selectors.getEntities,
  allLocations: locations.selectors.getEntities
});

export default connect(mapStateToProps, {
  ...actions,
  fetchClientsIfNeeded,
  fetchLocationsIfNeeded
})(ScheduleContainer);



// WEBPACK FOOTER //
// ./src/modules/sessions/components/ScheduleContainer.js